import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import LoadingV2 from './components/LoadingV2'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { history } from './store'

import { actions as employeeActions } from './actions/employee'
import { actions as configurationActions } from './actions/configuration'
import { actions as staticContentActions } from './actions/static_content'
import { actions as authenticationActions } from './actions/authentication'
import { actions as maintenanceActions } from './actions/maintenance'

import ApplicationLayout from './layouts/v1/ApplicationLayout'
import ApplicationLayoutV2 from './layouts/v2/ApplicationLayout'
import Dashboard from './components/v1/dashboard'
import { default as DashboardV2 } from './components/v2/dashboard'
import StockAwards from './components/v1/stockAwards'
import StockAwardsV2 from './components/v2/stockAwards'
import Broker from './components/v1/broker'
import BrokerV2 from './components/v2/broker'
import MoreAboutStocks from './components/v1/MoreAboutStocks'
import { default as MoreAboutStockV2 } from './components/v2/MoreAboutStock'
import PendingRequestDialog from './components/PendingRequestDialog';

import { NavigationTo, NAVIGATION_TAB_GROUP } from './layouts/v2/common'
import { TabPanel } from '@amzn/stencil-react-components/tabs'

class SecuredApp extends Component {

  componentDidMount() {
    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        if (!this.props.auth.auth) {
          this.props.actions.authentication.authenticate()
        }
      } else {
        history.push("/maintenance", {})
      }
    })

    // is it inclusive? why not use an else?
    if (this.props.auth.auth && this.props.auth.auth.id !== '') {
      var that = this
      this.props.actions.employee.load().then(e => {
        that.props.actions.static_content.load(e.language)
      })
      this.props.actions.configuration.load()
    }
  }

  componentDidUpdate(prevProps) {
    if ((!prevProps.auth.auth && this.props.auth.auth) ||
        (prevProps.auth.auth && this.props.auth.auth && prevProps.auth.auth.id !== this.props.auth.auth.id)) {

      // do not load the data below for impersonators
      if (this.props.auth.auth.id !== '') {
        prevProps.actions.employee.load().then(e => {
          prevProps.actions.static_content.load(e.language)
        })
        prevProps.actions.configuration.load()
      }
    }
  }

  render() {
    if (this.props.auth.loading || this.props.employee.loading || this.props.configuration.loading || this.props.static_content.loading) {
      return <LoadingV2 />
    }

    const enableNewStockPortalUi = this.props.employee.feature_flags ? this.props.employee.feature_flags.enable_new_stock_portal_ui : false;
    if (!enableNewStockPortalUi) {
      return (
        <ApplicationLayout>
          <PendingRequestDialog visible={this.props.employee.pendingRequest} />
          <Switch>
            <Route exact path='/' render={() => <Redirect to='/dashboard' />} />
            <Route path='/dashboard' render={() => <Dashboard />} />
            <Route path='/stock-awards' render={() => <StockAwards />} />
            <Route path='/broker' render={() => <Broker />} />
            <Route path='/more-about-stock'>
              <MoreAboutStocks/>
            </Route>
          </Switch>
        </ApplicationLayout>
      )
    } else {
      //This is only imported when a user is directed to V2 of Stock Portal as this negatively affects the CSS on V1 Stock Portal.
      import('reset-css')
      return (
        <ApplicationLayoutV2>
          <Switch>
            <Route exact path='/' render={() => <Redirect to={NavigationTo.AtGlance} />} />
            <Route path={NavigationTo.AtGlance}
              render={() => 
                <TabPanel value={NavigationTo.AtGlance} tabGroup={NAVIGATION_TAB_GROUP}>
                  <DashboardV2/>
                </TabPanel>
              } 
            />
            <Route path={NavigationTo.StockAwards}
              render={() => 
                <TabPanel value={NavigationTo.StockAwards} tabGroup={NAVIGATION_TAB_GROUP}>
                  <StockAwardsV2/>
                </TabPanel>
              } 
            />
            <Route path={NavigationTo.AvailableBrokers}
              render={() => 
                <TabPanel value={NavigationTo.AvailableBrokers} tabGroup={NAVIGATION_TAB_GROUP}>
                  <BrokerV2/>
                </TabPanel>
              } 
            />
            <Route path={NavigationTo.StockFAQs}
              render={() => 
                <TabPanel value={NavigationTo.StockFAQs} tabGroup={NAVIGATION_TAB_GROUP}>
                  <MoreAboutStockV2/>
                </TabPanel>
              } 
            />
          </Switch>
        </ApplicationLayoutV2>
      )
    }
  }
}

const mapState = state => ({
  employee: state.employee,
  configuration: state.configuration,
  static_content: state.static_content,
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    configuration: bindActionCreators(configurationActions, dispatch),
    static_content: bindActionCreators(staticContentActions, dispatch),
    authentication: bindActionCreators(authenticationActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)(withTranslation('translations')(SecuredApp))
